{
  "more": "פריטים נוספים"
}
